import { css } from '@emotion/core';
export var sticky = topEdgeOffset => /*#__PURE__*/css("position:fixed;top:", topEdgeOffset, "px;");
export var bottom = topEdgeOffset => /*#__PURE__*/css("position:absolute;top:", topEdgeOffset, "px;");
export var sidebox = {
  name: "bophd5",
  styles: "position:relative;width:320px;"
};